import WidgetLoader from 'components/WidgetLoader';
import WidgetVariantLoader from 'components/WidgetVariantLoader';
import { ClientProvider } from 'state/client';
import { DisplayUnitsProvider } from 'state/displayUnits/context';
import { PageDataProvider } from 'state/pageData';
import { SessionProvider } from 'state/session';
import { TextDirectionProvider } from 'state/textDirection';
import { TrackingProvider } from 'state/tracking';
import WidgetProvider from 'state/widget/context';

export interface AppProps {
  clientIp?: string;
  reactRoot: HTMLElement;
  sessionId?: string;
  title?: string;
  url?: string;
  widgetId: string;
  variantId?: string;
}

const App: React.FC<AppProps> = ({
  clientIp,
  sessionId,
  reactRoot,
  title,
  url,
  variantId,
  widgetId,
}) => (
  <TextDirectionProvider>
    <ClientProvider clientIp={clientIp}>
      <WidgetProvider>
        <DisplayUnitsProvider>
          <PageDataProvider {...{ reactRoot, title, url, widgetId }}>
            <SessionProvider sessionId={sessionId}>
              <TrackingProvider>
                <WidgetLoader overrides={{ variantId }}>
                  <WidgetVariantLoader />
                </WidgetLoader>
              </TrackingProvider>
            </SessionProvider>
          </PageDataProvider>
        </DisplayUnitsProvider>
      </WidgetProvider>
    </ClientProvider>
  </TextDirectionProvider>
);

export default App;
